import { Dispatch, FC, SetStateAction } from 'react';
import { Flex, UnstyledButton } from '@mantine/core';
import { useTranslation } from 'react-i18next';

import styles from './styles.module.scss';
import { AutomatedAuditLoader } from '@common/components';
import classNames from 'classnames';
import { numberLocalization } from 'src/helpers/numberLocalization';

interface IssuesByPriorityItemProps {
  title: string;
  filter: string;
  field: string;
  issueValue: number | string;
  icon: JSX.Element;
  loading: boolean;
  setSearchQuery: Dispatch<SetStateAction<{ [key: string]: string | null }>>;
  searchQuery: { [key: string]: string | null };
}

const IssuesByPriorityItem: FC<IssuesByPriorityItemProps> = ({
  title,
  issueValue,
  icon,
  loading,
  filter,
  field,
  setSearchQuery,
  searchQuery,
}) => {
  const [t] = useTranslation('automatedReports');

  return (
    <UnstyledButton
      className={classNames(styles['issue-card'], styles['issue-card-button'], {
        // [styles['active']]: searchQuery[filter] === field,
      })}
      // onClick={() => setSearchQuery((prevState) => ({ ...prevState, [filter]: field })) }
 >
      <Flex justify={'space-between'}>
        <span className={styles['reported-number']} aria-label={`${  issueValue == '--' ? `Zero ${t(`${title}`)} Issues` : `${issueValue} ${t(`${title}`)} Issues`}`}>
          {loading ? <AutomatedAuditLoader /> : numberLocalization(issueValue as number)}
        </span>
        {icon}
      </Flex>
      <p>{t(`${title}`)}</p>
    </UnstyledButton>
  );
};

export default IssuesByPriorityItem;
